/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import { CollectionView } from 'backbone.marionette';

import HeaderBarCellView from './HeaderBarCellView';

import './HeaderBarBodyView.css';

const HeaderBarBodyView = CollectionView.extend({
  className: 'header-bar-body-view d-flex flex-row',

  childView(model) {
    if (model.get('headerCell')) {
      return model.get('headerCell');
    }
    return HeaderBarCellView;
  },

  childViewOptions(model, index) {
    return {
      dataModel: this.model,
      columns: this.collection,
    };
  },
});

export default HeaderBarBodyView;
